import httpClient from '@/apis/base/httpclient'

export default class BaseAPI {
  baseUrl = '';
  controllerName = '';
  apiName = '';

  /**
   * Khởi tạo ApiUrl, API được khởi tạo dựa trên apiName
   */
  initAPI () {
    if (this.apiName) {
      this.baseUrl = window._apis[this.apiName] + '/' + this.controllerName
    }
  }

  /**
   * Build api url
   * @returns
   */
  getAPIUrl () {
    // Khi base url chưa khởi tạo
    if (!this.baseUrl) {
      this.initAPI()
    }

    // Nếu có truyền thêm argument thì nó khởi tạo thêm url
    if (arguments && arguments.length > 0) {
      return [this.baseUrl, ...arguments].join('/')
    }

    return this.baseUrl
  }

  /**
   * @param config: AxiosRequestConfig
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contentType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  postAsync = (...args) => httpClient.postAsync(...args)
  putAsync = (...args) => httpClient.putAsync(...args)
  getAsync = (...args) => httpClient.getAsync(...args)
  deleteAsync = (...args) => httpClient.deleteAsync(...args)

  /**
   * Lấy dữ liệu danh sách
   * Trả về các field truyền lên
   */
  getList (payload) {
    const request = {
      url: this.getAPIUrl('list'),
      data: payload,
    }

    return this.postAsync(request)
  }

  /**
   * Lấy dữ liệu danh sách
   * Trả về tất cả các field
   */
  getListEntity (payload) {
    const request = {
      url: this.getAPIUrl('list-paging'),
      data: payload,
    }

    return this.postAsync(request)
  }

  /**
  * Lấy dữ liệu danh sách phân trang summary
  */
  getListSummary (payload) {
    const request = {
      url: this.getAPIUrl('list-summary'),
      data: payload,
    }

    return httpClient.postAsync(request)
  }

  /**
   * Lấy ra tất cả bản ghi theo có filter
   * @param {*} payload
   * @returns
   */
  getAll (payload) {
    const request = {
      url: this.getAPIUrl('list-all'),
      data: payload,
    }

    return this.postAsync(request)
  }

  /**
   * Lấy dữ liệu danh sách tree
   */
  getTree (payload) {
    const request = {
      url: this.getAPIUrl('tree'),
      data: payload,
    }

    return httpClient.getAsync(request)
  }

  // /**
  //  * Lấy dữ liệu danh sách theo ids, ids là chuỗi phân cách bởi dấu ,
  //  */
  // getDataByIds (payload) {
  //   const request = {
  //     url: this.getAPIUrl() + '/ids',
  //     data: payload,
  //   }

  //   return httpClient.getAsync(request)
  // }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getNew (payload) {
    const request = {
      url: this.getAPIUrl('new'),
      data: payload,
    }

    return httpClient.getAsync(request)
  }

  // /**
  //  * Lấy dữ liệu autoID
  //  * @param {*} payload
  //  * @returns
  //  */
  // getAutoID (payload) {
  //   const request = {
  //     url: this.getAPIUrl('getAutoID'),
  //     data: payload,
  //   }

  //   return httpClient.getAsync(request)
  // }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getEdit (payload) {
    const request = {
      url: this.getAPIUrl(payload.id),
    }

    return httpClient.getAsync(request)
  }

  /**
   * Lấy bản ghi nhân bản
   */
  getDuplicate (payload) {
    const request = {
      url: this.getAPIUrl('duplicate'),
      data: payload,
    }

    return httpClient.getAsync(request)
  }

  /**
   * Thêm mới
   */
  insert (payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    }
    return httpClient.postAsync(request, true)
  }

  /**
   * Thêm mới
   */
  insertMulti (payload) {
    const request = {
      url: this.getAPIUrl('batch'),
      data: payload,
    }
    return httpClient.postAsync(request, true)
  }

  /**
   * Cập nhật
   */
  update (payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    }
    return httpClient.putAsync(request, true)
  }

  /**
   * Cập nhật nhiều bản ghi
   */
  updateMulti (payload) {
    const request = {
      url: this.getAPIUrl('batch'),
      data: payload,
    }
    return httpClient.putAsync(request, true)
  }

  /**
   * Xóa
   */
  delete (payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    }
    return httpClient.deleteAsync(request, true)
  }

  // /**
  //  * Lấy dữ liệu combobox load paging
  //  */
  // getComboboxPaging (payload) {
  //   const param = { ...payload }

  //   // xử lý tham số trước khi request load dữ liệu
  //   commonFn.processComboboxParamRequest(param)

  //   const request = {
  //     url: this.getAPIUrl() + '/list',
  //     data: param,
  //   }

  //   return httpClient.postAsync(request)
  // }
}
